<script setup lang="ts">
import { computed } from "vue";

import { applyActionParams } from "@/action/actions";
import { navigationActions } from "@/action/navigationActions";
import { action } from "@/components/action/action";
import { actionSourceKey } from "@/components/action/injectKeys";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import type { Iteration } from "@/model/session";
import { useWorkModeStore } from "@/store/workMode";
import { injectStrict } from "@/utils/vue";

import KebabMenu from "./KebabMenu.vue";

const props = defineProps<{ iteration: Iteration }>();

const actionSource = injectStrict(actionSourceKey);

const kanbanVisible = computed(() => useWorkModeStore().isExecutionMode);

const showKanban = computed(() =>
  action(applyActionParams(navigationActions.showKanban, { iterationId: props.iteration.id }), {
    source: actionSource,
  }),
);
</script>

<template>
  <span class="team-iterations-menu">
    <IconButton
      v-if="kanbanVisible"
      class="kanban-button"
      v-bind="showKanban"
      scale="board"
      :text="$t('label.iteration.kanban', { name: iteration.name })"
    />
    <KebabMenu
      mode="iteration"
      class="iteration-button"
      icon="system/more-vertical"
      scale="board"
      :tooltip="$t('label.iteration.kebabMenu', { name: iteration.name })"
    />
  </span>
</template>

<style lang="scss">
@use "@/styles/board";
@use "@/styles/z-index";
@use "@/styles/variables/colors";

.team-iterations-menu {
  display: flex;
  gap: board.len(8px);
  background-color: inherit;

  & > span {
    z-index: z-index.$board-controls;
    background-color: inherit;
  }

  span {
    display: flex;
  }
}
</style>
